// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5GRQt","title":"styles_title__1toL9"};